import Icon from './Icon.vue'
import CButton from './CButton.vue'
import DraftFroala from './DraftFroala.vue'
import CImage from './CImage.vue'
import CSurvey from './CSurvey.vue'
import Divider from './Divider.vue'
import CVideo from './CVideo.vue'
import CForm from './CForm.vue'
import BrandLogo from './BrandLogo.vue'
import BuyNowButton from './BuyNowButton.vue'
import CPopupBuilder from './CPopupBuilder.vue'
import CodeSnippet from './CodeSnippet.vue'
import Checkout from './Checkout/Checkout.vue'
import SubGridContainer from './SubGridContainer.vue'
import CountdownTimer from './CountdownTimer/CountdownTimer.vue'
import ActionButtons from './ActionButtons.vue'
import TopRightActionButtons from './c-container/TopRightActionButtons.vue'
import CContainer from './c-container/CContainer.vue'

export const components: Record<string, any> = {
  icon: Icon,
  'c-button': CButton,
  draft: DraftFroala,
  'c-image': CImage,
  'c-survey': CSurvey,
  divider: Divider,
  'c-video': CVideo,
  'c-form': CForm,
  'brand-logo': BrandLogo,
  'buy-now-button': BuyNowButton,
  'c-popup-builder': CPopupBuilder,
  'code-snippet': CodeSnippet,
  Checkout: Checkout,
  'sub-grid-container-v3': SubGridContainer,
  'countdown-timer': CountdownTimer,
  'action-buttons': ActionButtons,
  'top-right-action-buttons': TopRightActionButtons,
  'c-container': CContainer,
}
